function initPriceUpdater() {
  const EUR = 1.95583;

  function formatMoney(cents) {
    return (cents / 100).toFixed(2);
  }

  // function formatMoneyEUR(amount) {
  //   return `${(amount / 100 / EUR).toFixed(2)} €`;
  // }

  function updatePrice(radioButton) {
    const price = radioButton.getAttribute("data-price");
    const comparePrice = radioButton.getAttribute("data-compare-price");

    // Get section ID from radio button ID (everything before the last dash)
    const sectionId = radioButton.id.substring(
      0,
      radioButton.id.lastIndexOf("-"),
    );

    const discountBadge = document.getElementById(
      `discount-badge-${sectionId}`,
    );

    if (discountBadge) {
      if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
        // originalPrice.textContent = `${formatMoney(comparePrice)}`;
        // originalPrice.style.display = "inline";

        // euroOriginalPrice.textContent = `/ ${formatMoneyEUR(comparePrice)}`;
        // euroOriginalPrice.style.display = "inline";

        const discount = Math.round(
          ((comparePrice - price) / comparePrice) * 100,
        );

        discountBadge.textContent = `Спестяваш ${discount}%`;
        discountBadge.style.display = "inline";
      } else {
        discountBadge.style.display = "none";
      }
    }
  }

  // Listen for changes on variant radio buttons
  document.addEventListener("change", function (event) {
    if (event.target.matches("input.variant-radio")) {
      updatePrice(event.target);
    }
  });

  // Initialize all checked radios
  document.querySelectorAll("input.variant-radio:checked").forEach(updatePrice);
}

// Auto-initialize when DOM is ready
document.addEventListener("DOMContentLoaded", initPriceUpdater);
